import { HomeSection } from "./components/HomeSection";
import { ExperiencesSection } from "./components/ExperiencesSection";
import { ProjectsSection } from "./components/ProjectsSection";
import { SkillsSection } from "./components/SkillsSection";

export default function App() {
  return (
    <div className="bg-black text-white relative">
      <HomeSection />
      <ExperiencesSection />
      <ProjectsSection />
      <SkillsSection />
    </div>
  );
}
